__turbopack_context__.v({
  "addressLink": "StoreLocator-module__cxKl1a__addressLink",
  "badges": "StoreLocator-module__cxKl1a__badges",
  "bg": "StoreLocator-module__cxKl1a__bg",
  "imgDiv": "StoreLocator-module__cxKl1a__imgDiv",
  "pcImg": "StoreLocator-module__cxKl1a__pcImg",
  "storeCard": "StoreLocator-module__cxKl1a__storeCard",
  "titleDiv": "StoreLocator-module__cxKl1a__titleDiv",
});
